import axios from 'axios';
import { GuestSubmission } from '../models/GuestSubmission';

const API_URL = `https://wedding-api-v1cm.onrender.com`; 

 export const submitGuests = async (guests: GuestSubmission[]): Promise<boolean> => {
    try {
      const response = await axios.post(`${API_URL}/submit-guests`, {guests});
      return response.data.success;
    } catch (error: any) {
      if (!error.response) {
        console.error('Network error:', error);
      } else {
        console.error('Error response:', error.response);
      }
    }
    return false;
  };


   export const validateGuests = async (guests: GuestSubmission[]): Promise<GuestSubmission[]> => {
    try {
      var response = await axios.post(`${API_URL}/guest-check`, {guests});
      return response.data;
    } catch (error: any) {
      if (!error.response) {
        console.error('Network error:', error);
      } else {
        console.error('Error response:', error.response);
      }
      return guests;
    }
  };